module.exports = "<svg viewBox=\"0 0 17.1 14.1\"><path fill=\"#231F20\" d=\"M16.1 14.1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h15.1c.6 0 1 .4 1 1v12.1c0 .6-.4 1-1 1zM2 12.1h13.1V2H2v10.1z\"></path><path fill=\"#231F20\" d=\"M8.6 9.6c-.3 0-.6-.1-.8-.3L.3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0l7.6 7.6c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3z\"></path><path fill=\"#231F20\" d=\"M8.6 9.6c-.3 0-.6-.1-.8-.3-.4-.4-.4-1 0-1.4L15.4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.3 9.3c-.2.2-.5.3-.7.3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/mail.svg
// module id = 307
// module chunks = 1